<template>
  <svg id="icon_arrow_next_64" width="64" height="64" viewBox="0 0 64 64">
  <g id="타원_535" data-name="타원 535" class="cls-1">
    <circle class="cls-3" cx="32" cy="32" r="32"/>
    <circle class="cls-4" cx="32" cy="32" r="30"/>
  </g>
  <path id="패스_10124" data-name="패스 10124" class="cls-2" d="M-14966.184-22205h31.193l-10.945-11.561" transform="translate(14982 22239.061)"/>
</svg>
</template>
<script>
export default {
  name: 'IconGo',
  methods: {},
  mounted(){
    if(this.$store.getters.getSettingType == '1') {
      this.$el.querySelector('.cls-1').classList.add('custom-style-1');
      this.$el.querySelector('.cls-2').classList.add('custom-style-1');
    }
  },
};
</script>
<style scoped>
  .cls-1, .cls-2, .cls-4 {
    fill: none;
  }

  .cls-1, .cls-2 {
    stroke: var(--primary-ft-color);
    stroke-width: 4px;
  }

  .dark .cls-1, 
  .dark .cls-2 {
    stroke: var(--primary-ft-color-dark);
  }

  .cls-2 {
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .cls-3 {
    stroke: none;
  }

  .custom-style-1 {
    stroke: #ffffff !important;
  }
</style>
